<template>
  <div class="row no-gutters">
    <div class="offset-lg-1 col-lg-10">
      <h2>Ricerca</h2>
    </div>
    <div class="offset-lg-1 col-lg-10 mt-lg-2 d-flex d-sm-block justify-content-between">
      <toggle-button :checked="type === 'books'" @click="type = 'books'">Libri</toggle-button>
      <toggle-button class="ml-sm-2" :checked="type === 'authors'" @click="type = 'authors'">Autori</toggle-button>
      <toggle-button class="ml-sm-2" :checked="type === 'users'" @click="type = 'users'">Utenti</toggle-button>
    </div>
    <div class="offset-lg-1 col-lg-10 mt-lg-2">
      <books-search :class="{hidden: type !== 'books'}" :search-client="searchClient" v-model="search" :subscribed="subscribed" />
      <authors-search :class="{hidden: type !== 'authors'}" :search-client="searchClient" v-model="search" :subscribed="subscribed" />
      <users-search :class="{hidden: type !== 'users'}" :search-client="searchClient" v-model="search" :subscribed="subscribed" />
    </div>
  </div>
</template>

<script>
import {instantMeiliSearch} from "@meilisearch/instant-meilisearch";
import BooksSearch from "./SearchComponents/BooksSearch.vue";
import UsersSearch from "./SearchComponents/UsersSearch.vue";
import AuthorsSearch from "./SearchComponents/AuthorsSearch.vue";
import ToggleButton from "./Buttons/ToggleButton.vue";

export default {
  name: "Search",
  components: {ToggleButton, AuthorsSearch, UsersSearch, BooksSearch},
  data() {
    const params = new URLSearchParams(location.search);
    const previousSearch = params.get('search_term');
    const previousType = params.get('tab');
    return {
      search: previousSearch !== undefined ? previousSearch : '',
      type: !!previousType ? previousType: 'books',
      searchClient: instantMeiliSearch(process.env.MIX_MEILISEARCH_URL, process.env.MIX_MEILISEARCH_KEY)
    }
  },
  props: {
    previousSearch: String,
    subscribed: Boolean,
  },
  watch: {
    search(newSearch, oldSearch) {
      _.debounce((newSearch) => {
        const params = new URLSearchParams(location.search);
        const searchToSet = newSearch ? newSearch : '';
        params.set('search_term', searchToSet);
        window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
      }, 500)(newSearch);
    },
    type(newType, oldType) {
      const params = new URLSearchParams(location.search);
      params.set('type', newType);
      window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
    }
  },
}
</script>

<style scoped>
  .hidden {
    display: none;
  }
</style>
